"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CborMap = exports.isRawCborMap = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var _1 = require("./index.js");
var defaultOpts = Object.freeze({
    indefinite: false
});
function isRawCborMap(m) {
    if (typeof m !== "object" || m === null)
        return false;
    var keys = Object.keys(m);
    return (keys.includes("map") &&
        Array.isArray(m.map) &&
        m.map.every(function (entry) {
            if (typeof entry !== "object" || entry === null)
                return false;
            var entryKeys = Object.keys(entry);
            return (entryKeys.includes("k") &&
                (0, _1.isRawCborObj)(entry.k) &&
                entryKeys.includes("v") &&
                (0, _1.isRawCborObj)(entry.v));
        }));
}
exports.isRawCborMap = isRawCborMap;
var CborMap = /** @class */ (function () {
    function CborMap(map, options) {
        var indefinite = (options === null || options === void 0 ? void 0 : options.indefinite) === true ? true : defaultOpts.indefinite;
        (0, obj_utils_1.defineReadOnlyProperty)(this, "map", map);
        (0, obj_utils_1.defineReadOnlyProperty)(this, "indefinite", Boolean(indefinite));
    }
    CborMap.prototype.toRawObj = function () {
        return {
            map: this.map.map(function (entry) {
                return {
                    k: entry.k.toRawObj(),
                    v: entry.v.toRawObj()
                };
            }),
            options: {
                indefinite: this.indefinite
            }
        };
    };
    CborMap.prototype.clone = function () {
        return new CborMap(this.map.map(function (entry) { return ({
            k: entry.k.clone(),
            v: entry.v.clone()
        }); }), { indefinite: this.indefinite });
    };
    return CborMap;
}());
exports.CborMap = CborMap;
